
/**
 * 강의 콘텐츠 유형
 */
export type PublishCourseDraft200SectionsItemLecturesItemContentType = typeof PublishCourseDraft200SectionsItemLecturesItemContentType[keyof typeof PublishCourseDraft200SectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublishCourseDraft200SectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  CODING: 'CODING',
} as const;
